export var ScheduledJobActionType;
(function (ScheduledJobActionType) {
    ScheduledJobActionType[ScheduledJobActionType["IMPORT"] = 1] = "IMPORT";
    ScheduledJobActionType[ScheduledJobActionType["EXPORT"] = 2] = "EXPORT";
    ScheduledJobActionType[ScheduledJobActionType["REPORT"] = 3] = "REPORT";
})(ScheduledJobActionType || (ScheduledJobActionType = {}));
//# sourceMappingURL=scheduled-job-action-type.js.map